<div class="d-flex justify-content-between align-items-center">
    <div data-testid="snackbar-text" [innerHTML]="message | translate | markdownIt"></div>
    <button mat-button (click)="dismiss()" class="ms-3" data-testid="snackbar-action-button">
        {{ action | translate }}
    </button>
</div>
